import React from 'react';
import { Skeleton } from './skeleton';
import { Card, CardContent, CardHeader } from './card';

export const GroupTableSkeleton = () => (
  <Card className="overflow-hidden">
    <CardHeader className="nfl-gradient py-3 px-4">
      <Skeleton className="h-6 w-32 bg-primary-foreground/20" />
    </CardHeader>
    <CardContent className="p-4 space-y-3">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Skeleton className="h-5 w-5 rounded" />
            <Skeleton className="h-4 w-24" />
          </div>
          <div className="flex items-center space-x-4">
            <Skeleton className="h-4 w-10" />
            <Skeleton className="h-4 w-8" />
          </div>
        </div>
      ))}
    </CardContent>
  </Card>
);

export const ScoreTableSkeleton = ({ isMosaicView = false, groups = 4 }) => (
  <div className={
    isMosaicView
      ? 'grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6'
      : 'space-y-6'
  }>
    {Array.from({ length: groups }).map((_, i) => (
      <GroupTableSkeleton key={i} />
    ))}
  </div>
);

export const MainPageSkeleton = () => (
  <div className="space-y-4">
    <div className="flex flex-col md:flex-row justify-between items-center">
      <Skeleton className="h-8 w-48 mb-4 md:mb-0" />
      <div className="flex space-x-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} className="h-10 w-10" />
        ))}
      </div>
    </div>
    <Skeleton className="h-10 w-full" />
    <div className="flex space-x-2">
      {Array.from({ length: 5 }).map((_, i) => (
        <Skeleton key={i} className="h-8 w-16 rounded-full" />
      ))}
    </div>
    <ScoreTableSkeleton />
  </div>
);
